import CascateList from "../../../../../../common/components/cascate_list";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

type Props = {
  status?: string | null;
  equipamento?: string | null;
  responsavelPeloEquipamento?: string | null;
  dataCalibracaode?: Date | null;
  dataCalibracaoate?: Date | null;
  centrocustoDropDown: DropDown[];
  idsCentroCusto?: number[]

  onStatusChange: (newValue: string | null) => void;
  onEquipamentoChange: (newValue: string | null) => void;
  onResponsavelPeloEquipamentoChange: (newValue: string | null) => void;
  onCentroCustoChange: (newValue: number[]) => void;
  onhandleDataCalibracaoChange: (v: Date | null, x: Date | null) => void;
  onClear: () => void;
};


export const Header = ({
  centrocustoDropDown,
  status,
  equipamento,
  responsavelPeloEquipamento,
  dataCalibracaode,
  dataCalibracaoate,
  idsCentroCusto,
  onStatusChange,
  onEquipamentoChange,
  onResponsavelPeloEquipamentoChange,
  onhandleDataCalibracaoChange,
  onClear,
  onCentroCustoChange,

}: Props) => {

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
            <DefaultInput
              label="Pesquisar por Equipamento"
              name="search_by_sector"
              value={equipamento ?? ""}
              onChangeValue={onEquipamentoChange} />



            <DefaultInput
              label="Pesquisar por Responsável"
              name="search_by_sector"
              value={responsavelPeloEquipamento ?? ""}
              onChangeValue={onResponsavelPeloEquipamentoChange} />


            <FormControl size="small" fullWidth>
              <InputLabel id="modulo-dashboard">Status</InputLabel>
              <Select
                labelId="modulo-dashboard"
                label="Status"
                value={status}
                onChange={(e) => onStatusChange(String(e.target.value))}>
                <MenuItem value={"T"}>Todos</MenuItem>
                <MenuItem value={"A"}>Atrasados</MenuItem>
                <MenuItem value={"E"}>Em dia</MenuItem>
              </Select>
            </FormControl>

            <DefaultDateRangePickerInput
              label='Data Receber'
              dataDe={dataCalibracaode ?? null}
              dataAte={dataCalibracaoate ?? null}
              onChange={async (start, end) => {
                onhandleDataCalibracaoChange(start, end)
              }}
            />

            <DefaultMultiAutocomplete
              label='Centro de Custo'
              options={centrocustoDropDown}
              getOptionLabel={x => x.title}
              getOptionKey={x => x.id}
              value={idsCentroCusto ? centrocustoDropDown.filter(x => idsCentroCusto.includes(x.id)) : []}
              onChange={x => onCentroCustoChange(x ? x.map(item => item.id) : [])} />

          </div>

          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClear}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>


  );
}

